/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedApproverRoleListResponse } from '../types/PaginatedApproverRoleList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ApproverRolesListRequest = {} | null | undefined;
export type ApproverRolesListResponse = PaginatedApproverRoleListResponse;

export type ApproverRolesListQuery = {
  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/approver_roles/
 *
 * ```yaml
 * operationId: approver_roles_list
 * tags:
 *   - approver_roles
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedApproverRoleList'
 *     description: ''
 * ```
 */
export const approverRolesListOperation = (rest?: ApproverRolesListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/approver_roles/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/approver_roles/' };
  };

/**
 * GET /dmx-server/approver_roles/
 *
 * ```yaml
 * operationId: approver_roles_list
 * tags:
 *   - approver_roles
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedApproverRoleList'
 *     description: ''
 * ```
 */
export const approverRolesList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ApproverRolesListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedApproverRoleListResponse>> => {
  const operation = approverRolesListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/approver_roles/
 */
export const useApproverRolesListResource = (
  query: ApproverRolesListQuery | null,
  useCached?: boolean,
): UseResource<ApproverRolesListResponse> => {
  return useResource<ApproverRolesListResponse>({
    path: query === null ? null : approverRolesListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
